import React from 'react';
import { Header } from 'components/Header';
import SidebarComponent from 'components/Sidebar';
import styled from 'styled-components';

interface LayoutProps {
  children: React.ReactNode;
}

const Container = styled.div`
  width: 100%;
  height: 20vh;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const SidebarContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 10;
`;

const MainContainer = styled.div`
  flex: 1;
  margin-left: 80px; /* Largura do sidebar colapsado */
  margin-top: 32px; /* Altura do header */
  padding: 20px;
  overflow-y: auto;
  min-height: calc(100vh - 32px);

  /* Responsive para tablet/mobile */
  @media screen and (max-width: 820px) {
    margin-left: 0;
    padding: 5px;
  }
`;

export const Layout = ({ children }: LayoutProps) => {
  return (
    <Container>
      <Header />
      <SidebarContainer>
        <SidebarComponent />
      </SidebarContainer>
      <MainContainer>
        {children}
      </MainContainer>
    </Container>
  );
};

export default Layout;
